var _path, _path2, _path3, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRiskLevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 12.856C19.9999 8.43774 16.4182 4.85602 11.9999 4.85602C7.58166 4.85602 3.99994 8.43774 3.99994 12.856",
    stroke: "#1A1B1D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8085 18.357C19.1668 16.9232 19.9999 14.9869 19.9999 12.856C19.9999 8.43774 16.4182 4.85602 11.9999 4.85602C7.58166 4.85602 3.99994 8.43774 3.99994 12.856C3.99994 14.9869 4.83307 16.9232 6.19136 18.357",
    stroke: "#1A1B1D",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7427 12.5819L11.2266 12.5819L11.9847 9.25234L12.7427 12.5819Z",
    fill: "#1A1B1D",
    stroke: "#1A1B1D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.25,
    y: 12.6068,
    width: 3.5,
    height: 3.5,
    rx: 1.75,
    stroke: "#1A1B1D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskLevel);
export default __webpack_public_path__ + "static/media/risk-level.df74381a5332253c4f3819320f982c8d.svg";
export { ForwardRef as ReactComponent };